<template>
  <a-modal
    :visible="true"
    width="600px"
    title="导入数据"
    @ok="onSubmitEvent"
    :ok-button-props="{ loading: onSubmitLoading }"
    @cancel="onCancel"
    ok-text="提交"
    cancel-text="关闭"
    destroyOnClose
  >
    <a-upload
      :file-list="fileList"
      :before-upload="beforeUpload"
      @remove="handleRemove"
      :max-count="1"
      :accept="accept"
    >
      <slot name="uploadFile">
        <a-space>
          <a-button style="display: block">选取文件</a-button>
          <a href="javascript:;" @click.stop="templateDownload">模板下载</a>
        </a-space>
      </slot>
    </a-upload>
  </a-modal>
</template>
<script>
export default {
  name: 'ImportSimpleDataDialog.vue',
  props: {
    title: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: '.xls,.xlsx'
    },
    templateUrl: {
      type: String,
      default: ''
    },
    extraData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    uploadPromise: {
      type: Function,
      default: undefined,
      required: true
    }
  },
  data() {
    return {
      onSubmitLoading: false,
      fileObj: undefined,
      fileList: []
    }
  },
  methods: {
    beforeUpload(file) {
      this.fileList = [file]
      this.fileObj = file
      return false
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    onCancel() {
      this.$emit('cancel')
    },
    templateDownload() {
      if (this.templateUrl) {
        window.open(this.templateUrl)
      }
    },
    onSubmitEvent() {
      if (!this.fileList || this.fileList.length === 0) {
        return false
      }
      this.onSubmitLoading = true
      const file = this.fileObj
      const formData = new FormData()
      formData.append('file', file)
      if (this.extraData && typeof this.extraData !== 'object') {
        Object.keys(this.extraData).forEach((key) => {
          formData.append(key, this.extraData[key])
        })
      }
      if (this.uploadPromise && typeof this.uploadPromise === 'function') {
        this.onSubmitLoading = true
        this.uploadPromise(formData)
          .then(res => {
            this.onSubmitLoading = false
            this.onCancel()
            this.$emit('ok')
          })
          .catch(error => {
            this.onSubmitLoading = false
            if (error.msg) {
              this.$message.error(error.msg)
            }
            console.error(error)
          })
      } else {
        throw new Error('This uploadPromise does not defined.')
      }
    }
  }
}
</script>
<style scoped lang="less">
.tips {
  margin: 24px 0;
}

</style>